// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./resources/libs/critical/jquery-3.6.0.min.js");
var __webpack_exports__ = __webpack_require__("./resources/js/critical.js");
